// types
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
    openItem: ['dashboard'],
    openComponent: 'buttons',
    drawerOpen: false,
    componentDrawerOpen: true,
    nestedItems: {}
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.openItem = action.payload.openItem;
        },

        activeComponent(state, action) {
            state.openComponent = action.payload.openComponent;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload.drawerOpen;
        },

        toggleNested(state, action) {
            if (state.nestedItems[action.payload.itemId] != null) {
                state.nestedItems[action.payload.itemId] = action.payload.toggle;
            }
        },

        insertNested(state, action) {
            if (state.nestedItems[action.payload.itemId] == null) {
                state.nestedItems[action.payload.itemId] = false;
            }
        },

        openComponentDrawer(state, action) {
            state.componentDrawerOpen = action.payload.componentDrawerOpen;
        }
    }
});

export default menu.reducer;

export const { activeItem, activeComponent, openDrawer, toggleNested, insertNested, openComponentDrawer } = menu.actions;
